"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'collections';
exports.FETCH_COLLECTION = exports.namespace + "/FETCH_COLLECTION";
exports.FETCH_HOME_COLLECTION = exports.namespace + "/FETCH_HOME_COLLECTION";
exports.SET_COLLECTION_FILTER = exports.namespace + "/SET_COLLECTION_FILTER";
exports.CLEAR_COLLECTION_FILTERS = exports.namespace + "/CLEAR_COLLECTION_FILTERS";
exports.SET_COLLECTION_FILTERS = exports.namespace + "/RESET_COLLECTION_FILTERS";
exports.FETCH_BROWSE_CATEGORIES = exports.namespace + "/FETCH_BROWSE_CATEGORIES";
exports.COLLECTION_FILTER_GENRE = 'genre';
exports.COLLECTION_FILTER_SUBSCRIPTION = 'subscription';
exports.COLLECTION_FILTER_VIEWINGCONTEXT = 'viewingContext';
exports.COLLECTION_FILTER_SORT = 'sort';
exports.COLLECTION_FILTER_VALUE_ALL = 'all';
exports.COLLECTION_FILTER_VALUE_MYSUBSCRIPTION = 'mySubscription';
exports.COLLECTION_FILTER_VALUE_ONDEMAND = 'onDemand';
exports.COLLECTION_FILTER_VALUE_UPCOMING_ON_TV = 'upcomingOnTV';
exports.COLLECTION_FILTER_VALUE_DOWNLOADABLE = 'downloadable';
exports.COLLECTION_FILTER_VALUE_NEWEST = 'NEWEST';
//# sourceMappingURL=constants.js.map